// baseurl.js
export const baseURL = 'https://cdn-kultura.benatky.app';
